module.exports = new __parcel__URL__("trojan-avocado.59e5a35b.webp").toString();